<template>
  <Button class="back-button p-button-link" @click="goBack">
    <div class="icon-back" />
    <span>{{ $t("notifications.btn_back") }}</span>
  </Button>
</template>

<script>
export default {
  name: "ButtonBack",
  methods: {
    goBack() {
      this.$emit('back')
    },
  }
}
</script>

<style scoped lang="scss">
.back-button {
  display: flex;
  align-items: center;
  position: relative;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3D95CC;
  transition: .2s;
  padding-left: 0;
  padding-right: 0;

  &:hover {
    color: #3cafff;

    .icon-back {
      left: -2px;
    }
  }

  .icon-back {
    mask-image: url('~@/assets/images/icons/icon-back-arrow.svg');
    -webkit-mask-image: url('~@/assets/images/icons/icon-back-arrow.svg');
    mask-size: cover;
    -webkit-mask-size: cover;
    height: 8px;
    width: 14px;
    transform: rotate(-90deg);
    position: relative;
    left: 0;
    transition: .2s;
    background-color: currentColor;
    margin-right: 10px;
  }
}
</style>
